// extracted by mini-css-extract-plugin
export default {"wrapper":"Checkable_wrapper__OgnRI","add":"Checkable_add__5GIcV","label":"Checkable_label__aTdHc","required":"Checkable_required__NRU4+"};